// @flow

import React from "react";
import { Redirect } from "react-router";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import _ from "lodash";

import type { UserProfile } from "../types/user_profile";
import Firebase from "../lib/firebase";
import Config from "../lib/config";

type Props = {
  user: ?UserProfile,
  setUser: UserProfile => void,
  setTitle: string => void,
  location?: any,
  classes: Object
};

const styles = theme => ({
  container: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing.unit * 4
  },
  button: {
    margin: theme.spacing.unit
  }
});

class LoginView extends React.Component<Props> {
  componentDidMount = () => {
    this.props.setTitle("Login");
  };

  signIn = async () => {
    const user = await Firebase.signIn();
    const validEmail = _.some(Config.allowedEmailDomains, domain =>
      user.email.endsWith(domain)
    );
    if (validEmail) {
      this.props.setUser(user);
    }
    //TODO: Show error when using an invalid email domain
  };

  render = () => {
    const { classes } = this.props;

    if (this.props.user) {
      if (
        this.props.location &&
        this.props.location.state &&
        this.props.location.state.next
      ) {
        return <Redirect push to={this.props.location.state.next} />;
      } else {
        return <Redirect push to="/" />;
      }
    }

    return (
      <div className={classes.container}>
        <Button
          variant="raised"
          color="secondary"
          className={classes.button}
          onClick={this.signIn}
        >
          Login with Google
        </Button>
      </div>
    );
  };
}

export default withStyles(styles)(LoginView);



// WEBPACK FOOTER //
// ./src/views/LoginView.js